export const fr = {
  "nav.check_booking": "Vérifier la Réservation",
  "nav.admin": "Admin",
  "nav.book_now": "Réserver Maintenant",
  "nav.driver": "Chauffeur",
  "hero.badge": "Transport pour Étudiants Visa J1",
  "hero.title": "Easy Transportation",
  "hero.subtitle": "Votre Transport de Confiance des Aéroports de Chicago au Wisconsin",
  "hero.description": "Transport sûr, fiable et abordable pour les étudiants visa J1. Réservez votre prise en charge à l'aéroport ou votre trajet retour dès aujourd'hui !",
  "hero.book_trip": "Réservez Votre Trajet",
  "hero.check_status": "Vérifier le Statut de Réservation",
  "pricing.title": "Tarifs de Transport",
  "pricing.subtitle": "Tous les prix en USD",
  "pricing.ohare_mke": "Prise en charge (O'Hare / Milwaukee)",
  "pricing.midway": "Prise en charge (Midway)",
  "pricing.madison": "Madison vers Wisconsin Dells",
  "pricing.return": "Réduction Retour",
  "pricing.shared": "Trajet Partagé",
  "pricing.private": "Trajet Privé",
  "pricing.per_person": "par personne",
  "pricing.after_deposit": "après acompte de $20",
  "pricing.without_deposit": "sans acompte",
  "pricing.flat_rate": "tarif fixe",
  "pricing.per_suitcase": "Par valise",
  "pricing.carry_on": "Bagage à main",
  "pricing.free": "GRATUIT",
  "pricing.with_shipping": "Retour + expédition chez nous",
  "pricing.special_deal": "Offre Spéciale !",
  "pricing.midway_contact": "Contactez-nous pour les prix Midway (MDW)",
  "pricing.waterpark_note": "Les prix peuvent varier pour Three Bears Water Park ou d'autres destinations.",
  "pricing.contact_us": "Contactez-nous",
  "pricing.guidelines_title": "Comment Fonctionnent Nos Tarifs",
  "pricing.guidelines_deposit": "Un acompte de $20 par personne sécurise votre réservation. Le solde restant est dû le jour du trajet.",
  "pricing.guidelines_shared": "2 passagers ou plus voyageant le même jour vers le même aéroport obtiennent le tarif partagé.",
  "pricing.guidelines_solo": "Les voyageurs seuls (seul passager ce jour-là) peuvent être facturés un tarif légèrement plus élevé.",
  "pricing.guidelines_suitcase": "1 valise est incluse gratuitement pour les trajets retour. Chaque valise supplémentaire coûte $5.",
  "pricing.guidelines_payment": "Nous acceptons les paiements par Carte, Espèces et Zelle.",
  "requirements.title": "Conditions de Réservation",
  "requirements.pickup": "Nous proposons des prises en charge deux fois en 24 heures sauf notification contraire. Planifiez à l'avance !",
  "requirements.deposit": "Un acompte non remboursable de $20 USD est requis avant d'être ajouté au planning.",
  "requirements.seamless": "Sécurisez votre place en versant votre acompte à l'avance.",
  "requirements.final_payment": "Le solde restant est dû avant de monter dans le véhicule.",
  "special.title": "Destination Non Listée ?",
  "special.description": "Nous proposons des trajets sur demande vers des destinations hors de nos routes habituelles. Contactez-nous pour un devis personnalisé !",
  "special.call": "Appeler",
  "special.whatsapp": "WhatsApp",
  "features.title": "Pourquoi Choisir Easy Transportation ?",
  "features.subtitle": "Choisi par des milliers d'étudiants J1 chaque été",
  "features.easy_booking": "Réservation Facile",
  "features.easy_booking_desc": "Seulement $20 USD d'acompte requis. Payez par virement, carte, PayPal ou Zelle.",
  "features.safe": "Sûr et Fiable",
  "features.safe_desc": "Chauffeurs professionnels, véhicules confortables et support 24/7 pour les étudiants J1.",
  "features.flexible": "Horaires Flexibles",
  "features.flexible_desc": "Réservez arrivée et retour. Première valise gratuite au retour !",
  "video.badge": "Voyez-Nous en Action",
  "video.title": "Votre Voyage Commence Ici",
  "video.subtitle": "Regardez les étudiants J1 commencer leur aventure",
  "video.book_now": "Réservez Votre Trajet Maintenant",
  "booking.title": "Réservez Votre Trajet",
  "booking.step": "Étape",
  "booking.of": "de",
  "booking.trip_type": "Type de Trajet",
  "booking.arrival": "Arrivée (Prise en charge Aéroport)",
  "booking.return": "Retour (Vers l'Aéroport)",
  "booking.ride_type": "Type de Trajet",
  "booking.shared_ride": "Trajet Partagé",
  "booking.shared_desc": "Partagez avec d'autres passagers sur le même itinéraire",
  "booking.private_ride": "Trajet Privé",
  "booking.private_desc": "Véhicule exclusif rien que pour vous",
  "booking.pickup_location": "Aéroport de Prise en Charge",
  "booking.select_airport": "Sélectionner l'Aéroport",
  "booking.travel_date": "Date de Voyage",
  "booking.travel_time": "Heure d'Arrivée Prévue",
  "booking.departure_time": "Heure de Départ",
  "booking.flight_number": "Numéro de Vol",
  "booking.airline": "Compagnie Aérienne",
  "booking.terminal": "Terminal d'Arrivée",
  "booking.full_name": "Nom Complet",
  "booking.whatsapp": "Numéro WhatsApp",
  "booking.email": "Adresse Email",
  "booking.housing": "Logement",
  "booking.select_housing": "Sélectionner le Logement",
  "booking.custom_address": "Entrer l'Adresse Personnalisée",
  "booking.num_passengers": "Nombre de Passagers",
  "booking.suitcases": "Total de Valises",
  "booking.shipping": "Utilisez-vous T&M Courier ?",
  "booking.payment": "Mode de Paiement",
  "booking.referral": "Code de Parrainage",
  "booking.next": "Suivant",
  "booking.previous": "Précédent",
  "booking.submit": "Finaliser la Réservation",
  "booking.processing": "Traitement...",
  "booking.start_over": "Recommencer",
  "booking.first_time": "Premier Voyage",
  "booking.returning": "Client de Retour",
  "booking.confirmation_number": "Numéro de Confirmation",
  "pricing_summary.title": "Résumé des Tarifs",
  "pricing_summary.trip_price": "Prix du Trajet",
  "pricing_summary.luggage_fee": "Frais de Bagages",
  "pricing_summary.deposit": "Acompte",
  "pricing_summary.per_person": "par personne",
  "pricing_summary.discount": "Réduction Parrainage",
  "pricing_summary.total_now": "Total Dû Maintenant",
  "pricing_summary.balance": "Solde Restant",
  "success.title": "Réservation Confirmée !",
  "success.confirmation": "Numéro de Confirmation",
  "success.details": "Détails de la Réservation",
  "success.whatsapp_optin": "Recevoir les mises à jour via WhatsApp",
  "success.home": "Retour à l'Accueil",
  "driver.title": "Tableau de Bord Chauffeur",
  "driver.login": "Connexion Chauffeur",
  "driver.phone": "Numéro de Téléphone",
  "driver.pin": "Code PIN",
  "driver.sign_in": "Se Connecter",
  "driver.trips_today": "Trajets Aujourd'hui",
  "driver.upcoming": "Trajets à Venir",
  "driver.passengers": "passagers",
  "driver.suitcases": "valises",
  "driver.navigate": "Naviguer vers la Prise en Charge",
  "driver.contact": "Contacter le Passager",
  "driver.complete": "Terminer le Trajet",
  "driver.logout": "Déconnexion",
  "driver.no_trips": "Aucun trajet prévu",
  "common.loading": "Chargement...",
  "common.error": "Une erreur est survenue",
  "common.save": "Enregistrer",
  "common.cancel": "Annuler",
  "common.close": "Fermer",
  "common.details": "Détails",
  "common.status": "Statut",
  "common.date": "Date",
  "common.time": "Heure",
  "common.price": "Prix",
  "common.passenger": "Passager",
  "common.passengers": "Passagers",
};
